import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import clsx from 'clsx';
import { AutoCompleteStyle } from './Component.style';
import { ReactComponent as Exclamation } from 'assert/images/Common/exclamation.svg';

export default function AutoComplete({
  Options = [],
  className,
  label,
  required,
  onChange,
  value = '',
  errMsg,
  helperText,
  rightLabel,
  onRightLabel,
  textPlaceholder,
  onBlur,
  maxLimit,
  textInputValue,
  autoCompleteInputValue,
  ...props
}) {
  return (
    <AutoCompleteStyle>
      <div className={clsx('inputContainer', className)}>
        <div className="labelContainer">
          {label && (
            <div className="lebelView">
              <label>
                {label} {required && <span className="requiredSymbol">*</span>}
              </label>
            </div>
          )}
          {/* {rightLabel && (
            <div className="rightLabel">
              <div onClick={onRightLabel}>
                <a>{rightLabel}</a>
              </div>
            </div>
          )} */}
        </div>
        <Autocomplete
          disablePortal
          value={value}
          inputValue={autoCompleteInputValue}
          options={Options}
          onChange={(_, newValue) => {
            if (onChange) onChange(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              inputProps={{ ...params.inputProps, maxLength: maxLimit || 100 }}
              placeholder={textPlaceholder}
              onBlur={onBlur && onBlur}
            />
          )}
          {...props}
        />
        {errMsg && (
          <span className="errMsg">
            <Exclamation />
            {errMsg}
          </span>
        )}
      </div>
    </AutoCompleteStyle>
  );
}
